
import { Link, useLocation } from 'react-router-dom';

export default function BottomNav() {
  const location = useLocation();

  // La barra de abajo es para lo que se anota TODOS LOS DÍAS.
  //
  // Antes estaba Crecimiento y faltaba Pañales, que es exactamente al
  // revés de como se usa la app: el peso y la talla se miden una vez al
  // mes, en el control; los pañales, seis veces al día. Para llegar a
  // pañales había que pasar por el panel.
  //
  // Crecimiento no se pierde: sigue en los accesos del panel, que es
  // donde uno entra cuando vuelve del pediatra con la medida nueva.
  const navItems = [
    { icon: 'ri-robot-2-line', activeIcon: 'ri-robot-2-fill', label: 'SOS AI', path: '/ai-chat' },
    { icon: 'ri-user-smile-line', activeIcon: 'ri-user-smile-fill', label: 'Bebé', path: '/dashboard' },
    { icon: 'ri-restaurant-line', activeIcon: 'ri-restaurant-fill', label: 'Comida', path: '/feeding' },
    { icon: 'ri-hotel-bed-line', activeIcon: 'ri-hotel-bed-fill', label: 'Sueño', path: '/sleep' },
    { icon: 'ri-drop-line', activeIcon: 'ri-drop-fill', label: 'Pañales', path: '/diapers' },
    { icon: 'ri-syringe-line', activeIcon: 'ri-syringe-fill', label: 'Vacunas', path: '/vaccination' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-6 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex flex-col items-center justify-center space-y-1 transition-colors px-1
                ${isActive 
                  ? 'text-orange-600 bg-orange-50' 
                  : 'text-gray-600 hover:text-orange-600'
                }
              `}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
